import { useEffect } from 'react';
import '../../components/landing/landing-tailwind.css';
import Navbar from '../../components/landing/Navbar';
import HeroScroll from '../../components/landing/HeroScroll';
import TrustBar from '../../components/landing/TrustBar';
import Results from '../../components/landing/Results';
import Features from '../../components/landing/Features';
import HowItWorks from '../../components/landing/HowItWorks';
import Integration from '../../components/landing/Integration';
import NaverIntegration from '../../components/landing/NaverIntegration';
import Pricing from '../../components/landing/Pricing';
import Reviews from '../../components/landing/Reviews';
import Support from '../../components/landing/Support';
import FAQ from '../../components/landing/FAQ';
import CTABridge from '../../components/landing/CTABridge';
import Footer from '../../components/landing/Footer';
import FloatingCTA from '../../components/landing/FloatingCTA';
import './LandingPage.css';

const LandingPage = () => {
  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const prevHtmlOverflow = html.style.overflow;
    const prevBodyOverflow = body.style.overflow;
    const prevHtmlHeight = html.style.height;
    const prevBodyHeight = body.style.height;

    html.style.overflow = 'visible';
    html.style.height = 'auto';
    body.style.overflow = 'visible';
    body.style.height = 'auto';

    return () => {
      html.style.overflow = prevHtmlOverflow;
      html.style.height = prevHtmlHeight;
      body.style.overflow = prevBodyOverflow;
      body.style.height = prevBodyHeight;
    };
  }, []);

  return (
    <div className="landing-page font-[Pretendard_Variable,Pretendard,sans-serif] antialiased bg-white text-neutral-900">
      <Navbar />
      <HeroScroll />
      <TrustBar />
      <Results />
      <Features />
      <HowItWorks />
      <Integration />
      <NaverIntegration />
      <Pricing />
      <Reviews />
      <Support />
      <FAQ />
      <CTABridge />
      <Footer />
      <FloatingCTA />
      <div className="grain-overlay" aria-hidden="true" />
    </div>
  );
};

export default LandingPage;
